var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar"},[_c('div',{staticClass:"nav-side left"},[(!_vm.isHome)?_c('div',{staticClass:"nav-back",on:{"click":_vm.goHome}},[_c('span',{staticClass:"arrow"},[_vm._v("‹")]),_c('span',[_vm._v("首页")])]):_vm._e()]),_c('div',{staticClass:"nav-title"},[_vm._v(_vm._s(_vm.pageTitle))]),_c('div',{staticClass:"nav-side right"})])
}
var staticRenderFns = []

export { render, staticRenderFns }